export const environment = {
  API_PREFIX:
    import.meta.env.VITE_API_PREFIX ||
    "https://api-staging.virtualprogaming.com",
  ASSET_URL: import.meta.env.VITE_ASSET_URL || "https://vpgassets.gumlet.com/",
  DIGITAL_OCEAN_URI:
    "https://vpg-prod-user-uploads.fra1.digitaloceanspaces.com/",
  CDN_URI:
    "https://virtualprogaming.com/cdn-cgi/imagedelivery/cl8ocWLdmZDs72LEaQYaYw/",
  STRIPE_KEY:
    import.meta.env.VITE_STRIPE_KEY || "pk_test_HRu0ppq8jNZGCrToLiceCZ7Q",
  NAME: import.meta.env.VITE_ENV_NAME || "dev",
  GA4_MEASURE_ID: import.meta.env.VITE_GA4_MEASURE_ID || "UA-92918306-1",
  CLARITY_PROJECT_ID: import.meta.env.VITE_CLARITY_PROJECT_ID || "vi1rvgrtrb",
  EA_SECRET:
    import.meta.env.VITE_EA_SECRET || "7b39be585d364a50b78ceb3e2548231b",
};
